// TODO: Convert assessment-report.html to this component
// Use: useQuery with getReport from assessmentService

export default function AssessmentReportPage() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>📊 Assessment Report</h1>
      <p style={{ color: 'var(--text-secondary)' }}>
        View AI-generated assessment
      </p>
    </div>
  )
}
